import { Component } from '@angular/core';

export enum MenuFoodEnum {
    Restaurants = 1,
    Categories = 2,
    Modifiers = 3,
    ModifierGroups = 4,
    Products = 5
}

@Component({
    selector: 'food-root',
    templateUrl: './food-root.component.html',
    styleUrls: ['./food-root.component.scss']
})
export class FoodRootComponent {
    public menuEnum = MenuFoodEnum;
    public activeMenu: MenuFoodEnum = MenuFoodEnum.Restaurants;

    public clickMenu(menu: MenuFoodEnum) {
        this.activeMenu = menu;
    }
}
